import React from 'react';
import JudgeForm from '../components/JudgeForm';

const JudgePage = () => {
  return <JudgeForm />;
};

export default JudgePage;
